<template>
  <div>
    <v-card-actions class="card-bg-2">
      <AddDataTypeDialog v-model="dataSources" :mfId="mfId" />
    </v-card-actions>
    <v-divider />
    <v-data-table hide-actions :headers="headers" :items="dataSources" no-data-text="It's looking empty here. Add some data types!">
      <template v-slot:items="{ item }">
        <td>{{ item.name }}</td>
        <td>{{ item.dataTypeName }}</td>
      </template>
    </v-data-table>
    <v-divider />
  </div>
</template>

<script>
  import {
    SOURCE_TYPES_WITH_NAME_INDEX,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import AddDataTypeDialog from './AddDataTypeDialog'

  export default {
    components: {
      AddDataTypeDialog,
    },
    props: {
      value: Array,
      mfId: Number,
      displayName: String,
    },
    data: () => ({
      selected: null,
      headers: [{
        text: 'Source Name',
        value: 'name',
        align: 'left',
      },
      {
        text: 'Data Source Type',
        value: 'dataTypeName',
        align: 'left',
      },
      ],
    }),
    computed: {
      dataSources: {
        get() {
          return (this.value || []).map(ds => {
            let sourceType = SOURCE_TYPES_WITH_NAME_INDEX[ds.sourceType]
            return {
              ...ds,
              dataTypeName: sourceType && sourceType.dataType,
            }
          })
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
  }
</script>